export default __webpack_public_path__ + "assets/playaDelCarmen.40c3c497.jpg";